//
//
//
//
//
//
//
//

import Vue from "vue";
import VueMq from "vue-mq";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

export default {
  name: "NsTopnavLinkList",
  props: {
    links: {
      type: [Array, String, undefined],
      default: JSON.stringify("[]")
    }
  },
  data: function() {
    return {
      localLinks: []
    };
  },
  computed: {
    limitedLinks() {
      return this.localLinks.slice(0, 4).filter(link => !!link.text);
    }
  },
  watch: {
    links: {
      immediate: true,
      handler(newVal) {
        this.localLinks = [];
        if (newVal) {
          if (typeof newVal === "string") {
            const newValJson = JSON.parse(newVal) || [];
            if (typeof newValJson === "string") {
              this.localLinks = JSON.parse(newValJson) || [];
            } else {
              this.localLinks = newValJson;
            }
          } else {
            this.localLinks = [...newVal];
          }
        }
      }
    }
  }
};
